























import {Form, FormItem, Footer} from 'element-ui'
import {Component, Mixins, Prop, Ref, Watch} from 'vue-property-decorator'
import TitleAndMessage from '@/components/TitleAndMessage.vue'
import Translation from '@/mixins/Translation'
import MainLayout from '@/layouts/default/MainLayout.vue'
import HeaderLayout from '@/components/Header.vue'
import FooterLayout from '@/components/Footer.vue'
import FooterButton from '@/components/FooterButton.vue'
import ReadOnlyFormItem from '@/components/ReadOnlyFormItem.vue'
import FloatingLabelInput from '@/components/FloatingLabelInput.vue'
import {namespace} from 'vuex-class'

const auth = namespace('auth')
const layout = namespace('layout')

@Component({
  components: {
    ReadOnlyFormItem,
    FloatingLabelInput,
    FooterButton,
    TitleAndMessage,
    MainLayout,
    HeaderLayout,
    FooterLayout,
    [FormItem.name]: FormItem,
    [Form.name]: Form,
    [Footer.name]: Footer,
  }
})
export default class UserInfoEditPage extends Mixins(Translation) {
  @Prop({default: 'terms', type: String}) translation: string
  @Prop({default: false, type: Boolean}) isAnimation: boolean
  @Prop({default: 0, type: Number}) windowScrollY: number

  @Ref('formRef') readonly formRef!: Form
  @Ref('nameInputRef') readonly nameInputRef!: any

  @auth.Action('updateUser') updateUser
  @auth.State('name') userName: string
  @auth.State('phone') phone: string
  @auth.State('email') email: string
  @layout.Mutation('updateError') updateError

  name: string = ''
  loading: boolean = false

  get message() {
    const {ts} = this
    return {
      title: [`${ts('edit')}할 ${ts('my')} ${ts('individual')}${ts('info')}를`, `${ts('input')}해주세요`]
    }
  }

  get rules() {
    const {ts} = this
    return {
      name: [
        {required: true, trigger: ['blur', 'change'], message: `${ts('name')}을 ${ts('input')}해주세요`},
      ]
    }
  }

  @Watch('userName', {immediate: true})
  __userName(value) {
    this.name = value
  }

  @Watch('isAnimation')
  __isAnimation(value) {
    if(!value) {
      this.$nextTick(() => {
        this.nameInputRef?.focus()
      })
    }
  }

  onEnterName() {
    this.formRef.validate((valid) => {
      if(valid) {
        this.loading = true
        this.updateUser({name: this.name})
          .then(() => {
            this.goUserPage()
          })
          .catch((error) => {
            this.updateError({
              id: 'update-user',
              message: `${this.ts('name')}을 저장하는데 ${this.ts('failed')}하였습니다.`,
            })
            throw error
          })
          .finally(() => {
            this.loading = false
          })
      }
    })
  }

  goUserPage() {
    this.$router.push({name: 'user'}).catch((e) => e)
  }

  onClickBackward() {
    this.goUserPage()
  }
}
